import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { TransactionTable, EmptyMessage } from "./styles";
import { checkIEBrowser } from "../../../../utils/commonUtil";
import { exportTxnData } from "../../Pages/actions";

const TransactionDetailsTable = props => {
  let emptyStateText = '';
  if (props.tabName && !props.searchText) {
    switch (props.tabName) {
      case "contributions":
        emptyStateText = `There are no contributions for the selected time frame.`
        break;
      case "grants":
        emptyStateText = `There are no grants for the selected time frame.`
        break;
      case "exchange":
        emptyStateText = `There are no exchanges for the selected time frame.`
        break;
      case "other_transactions":
        emptyStateText = `There are no other transactions for the selected time frame.`
        break;
      case "all_transactions":
        emptyStateText = `There are no transactions for the selected time frame.`
        break;
      case "account_balance":
        emptyStateText = `There is no account balance history for the selected time frame.`
        break;
      default:
        emptyStateText = `There are no transactions for the selected time frame.`
        break;
    }
  } else {
    emptyStateText = `No Search Results Found`
  }
  return (
    <div data-test="transaction-details-table">
      <TransactionTable        
        className={`tansactionTableWrapper ${props.className ? props.className: ''}`}
        ie={checkIEBrowser()}
        data-test='transactionTable'
        pagination={false}
        columns={props.columns}
        dataSource={props.data}
        paddingVal={props.paddingVal}
        paddingHeadVal={props.paddingHeadVal}
        onChange={(pagination, filters, sorter, extra) => {
          props.exportTxnData({ tab: props.tabIdentifier, data: extra.currentDataSource });
          }
        }
        scroll={props.scroll}
        locale={{
          emptyText: (
            <div class='ant-empty ant-empty-normal' data-test='transactionTable-empty-state'>
              <EmptyMessage class='ant-empty-description'>
                <div>{emptyStateText}</div>
              </EmptyMessage>
            </div>
          )
        }}
      />
    </div>
  );
};

TransactionDetailsTable.propTypes = {
  alignAmountColumn: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
  data: PropTypes.arrayOf(PropTypes.object),
  searchText: PropTypes.string,
  tabName: PropTypes.string
}

// export default TransactionDetailsTable;

const mapDispatchToProps = dispatch => {
  return {
    exportTxnData: data => dispatch(exportTxnData(data)),
  };
};

export default connect(null, mapDispatchToProps)(TransactionDetailsTable);
